import { initGoogleAnalytics } from './lib/google-analytics';
import { renderSite } from './site/render-site';
import { hydratePublicStats } from './site/hydrate-public-stats';

initGoogleAnalytics();

import './styles/tokens.css';
import './styles/global.css';
import './styles/components.css';
import './styles/layout.css';
import './styles/business-register.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Missing #root');
}

renderSite(root);
void hydratePublicStats();

/** Cierra el menú «Más» del header al elegir un enlace (mejor en SPA de anclas). */
document.querySelectorAll('.sv-nav-dropdown__panel a').forEach((a) => {
  a.addEventListener('click', () => {
    document.querySelectorAll('.sv-nav-dropdown[open]').forEach((d) => {
      (d as HTMLDetailsElement).removeAttribute('open');
    });
  });
});
